/**
 * SecureEmbed Tier 2 Dashboard Entry Point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { initRUM } from '@secureembed/shared-crm';
import App from './App';
import './index.css';

initRUM('SECUREEMBED_CONFIG')

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
